let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fohKY")).then(() => parcelRequire('6KC4T'));